module.exports = __webpack_public_path__ + "img/proyecto9.09e7b96f.png";